<template>
  <div class="home-child-wrapper">
    <el-container>
      <el-aside width="340px">
        <div class="right-aside">
          <div class="profile-wrapper">
            <UserProfile :profile="curUser" :profileMenu="profileMenu" />
          </div>
          <div class="tab-menu-wrap" v-if="isLoginUser">
            <ul class="menu-container">
              <li
                v-for="(item, index) in menuTab"
                :key="index"
                class="menu-item"
              >
                <router-link :to="item.path" active-class="is-selected">
                  <span :class="item.icon">{{ item.name }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </el-aside>
      <el-main>
        <div class="tab-content-wrap">
          <router-view />
        </div>
        <PhotoPreviewer />
        <AvatarPreviewer />
      </el-main>
    </el-container>
    <div class="message-aside">
      <MessageMenu />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../utils/apiMap";
import UserProfile from "../components/UserProfile";
import PhotoPreviewer from "../components/PhotoPreviewer";
import AvatarPreviewer from "../components/AvatarPreviewer";
import MessageMenu from "../components/message-aside/message-menu";
export default {
  name: "users",
  data() {
    let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
    let feedPath = `/feed?id=${loginUser.userId}`;
    return {
      curUser: {},
      isLoginUser: false,
      profileMenu: {
        linkBtn: false,
        addFriendBtn: false,
        copyTreeBtn: false,
        modifyTreeBtn: false,
        applyTreeBtn: false,
        setRemarkBtn: false,
      },
      menuTab: [
        { name: "动态", path: feedPath, icon: "feed-icon" },
        { name: "账户", path: "/account", icon: "account-icon" },
        { name: "资料", path: "/profile", icon: "profile-icon" },
        { name: "安全", path: "/safety", icon: "safety-icon" },
        { name: "家谱", path: "/tree", icon: "tree-icon" },
        { name: "文章", path: "/article", icon: "article-icon" },
        { name: "相册", path: "/album", icon: "album-icon" },
        { name: "视频", path: "/video", icon: "video-icon" },
        { name: "音频", path: "/audio", icon: "audio-icon" },
      ],
    };
  },
  components: {
    UserProfile,
    PhotoPreviewer,
    AvatarPreviewer,
    MessageMenu,
  },
  computed: {
    ...mapGetters([
      "user",
      "userProfile",
      "userCenterSign",
      "conversationList",
      "currentConversation",
      "contactsList",
      "croupsList",
      "commentList",
    ]),
  },
  beforeMount() {
    this.getCurUserProfile(this.$route.query.id);
  },
  mounted() {
    this.initToggleTab();
    this.$bus.$on("update-user-profile", this.updateUserProfile);
    this.$bus.$on("update-friend-profile", this.updateFriendProfile);
    this.$bus.$on("set-user-profile", this.setUserProfile);
    this.getUserPermission();
  },
  methods: {
    initToggleTab() {
      let curPathName = this.$route.name;
      let nameArray = [
        "UserAccount",
        "UserData",
        "UserSafety",
        "UserTree",
        "UserArticle",
        "UserAlbum",
        "UserVideo",
        "UserAudio",
      ];
      if (nameArray.includes(curPathName)) {
        this.setUserProfile();
      } else {
        let newArray = ["UserFollow", "UserFans"];
        if (newArray.includes(curPathName)) {
          if (!this.$route.query.id) {
            window.history.back(-1);
          }
          //this.getCurUserProfile(userID);
        }
      }

      // var viewArray = ['FeedTab','AccountTab','ProfileTab','SafetyTab','TreeTab','ArticleTab','AlbumTab','VideoTab','AudioTab'];
      // 'UserAccount','UserProfile','UserSafety','UserTree','UserArticle','UserAlbum','UserVideo','UserAudio',
      // let curIndex =
      //this.toggle(this.$route.query.menu,this.menuTab[this.$route.query.menu].view);
      // let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      // if (this.$route.query.id==loginUser.userId) {
      //    this.active = this.userCenterSign.active||0;
      //    this.currentView = viewArray[this.active];
      // } else {
      //     this.active = 0;
      // }
    },
    toggle(index, view) {
      this.active = index;
      // '/feed','/account','/profile','/safety','/tree','/article','/album','/video','/audio',
      // this.currentView = view;
      // this.$route.query.menu = index
      // let query = this.$router.history.current.query;
      // let path = this.$router.history.current.path;
      //对象的拷贝
      // let newQuery = JSON.parse(JSON.stringify(query));
      // newQuery.menu = index;
      // this.$router.push({ path, query: newQuery });
      //个人中心菜单切换时 重置所有列表初始页
      // const initUserSign = {
      //     active: index,
      //     feedPage: 1,
      //     articlePage: 1,
      //     albumPage: 1,
      //     audioPage: 1,
      //     videoPage: 1,
      // }
      // Store.dispatch("setUserCenterSign", initUserSign);
    },
    getCurUserProfile(userID) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      if (!loginUser) {
        return;
      }
      var params = `token=${loginUser.token}`;
      if (loginUser.userId != userID) {
        params = `token=${loginUser.token}&userId=${userID}`;
      }
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["getProfile"]["method"],
          url: apiMap["getProfile"]["url"],
          data: params,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.curUser = response.data.result.data;
            if (loginUser.userId == response.data.result.data.userId) {
              // 我的主页
              _this.isLoginUser = true;
              _this.profileMenu.applyTreeBtn = false;
              _this.profileMenu.copyTreeBtn = false;
              _this.profileMenu.modifyTreeBtn = false;
              _this.profileMenu.addFriendBtn = false;
              let userProfile = response.data.result.data;
              if (!userProfile.headImgUrl) {
                userProfile.avatar = Store.state.defaultAvatar.C2C;
              } else {
                userProfile.avatar = userProfile.headImgUrl;
              }
              Store.dispatch("setUserProfile", userProfile);
            } else {
              // 他人的主页
              _this.isLoginUser = false;
              _this.getFirendList(function(res) {
                let findUser = res.filter(
                  (element) => element.userId == userID
                );
                // 判断是否为好友
                if (findUser.length == 0) {
                  _this.profileMenu.addFriendBtn = true;
                  _this.profileMenu.applyTreeBtn = false;
                  _this.profileMenu.copyTreeBtn = false;
                  _this.profileMenu.modifyTreeBtn = false;
                  _this.profileMenu.setRemarkBtn = false;
                } else {
                  _this.profileMenu.addFriendBtn = false;
                  _this.profileMenu.setRemarkBtn = true;
                  if (
                    response.data.result.data.inFatherFamilyTree == 0 &&
                    response.data.result.data.inMotherFamilyTree == 0
                  ) {
                    _this.profileMenu.applyTreeBtn = true;
                    _this.profileMenu.copyTreeBtn = true;
                    _this.profileMenu.modifyTreeBtn = false;
                  } else {
                    _this.profileMenu.modifyTreeBtn = true;
                  }
                }
              });
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getFirendList(okCbk) {
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["friendsList"]["method"],
          url: apiMap["friendsList"]["url"],
          data: "token=" + loginUser.token,
        })
        .then(function(response) {
          var newList = [];
          if (response.data.result.statusCode == 1) {
            newList = response.data.result.data.filter((item) => {
              return item.userId != loginUser.userId;
            });
            //刷新好友列表
            let contactList = new Array();
            newList.forEach((item) => {
              let remark = "";
              let displayHeadImg = Store.state.defaultAvatar.C2C;
              if (item.thumbHeadImg) {
                displayHeadImg = item.thumbHeadImg;
              } else if (item.headImgUrl) {
                displayHeadImg = item.headImgUrl;
              }
              if (item.markInfo) {
                remark = item.markInfo.mark;
              }
              item.avatar = displayHeadImg;
              item.remark = remark;
              contactList.push(item);
            });
            Store.dispatch("setContactList", contactList);
          }
          okCbk(newList);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    updateUserProfile() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["getProfile"]["method"],
          url: apiMap["getProfile"]["url"],
          data: `token=${loginUser.token}`,
        })
        .then(function(response) {
          // console.log(response.data.result.data)
          if (response.data.result.statusCode == 1) {
            _this.curUser = response.data.result.data;
            Store.dispatch("setUserProfile", response.data.result.data);
            var newAvatar =
              response.data.result.data.thumbHeadImg ||
              response.data.result.data.headImgUrl;
            var uptodateInfo = _this.user;
            if (newAvatar) {
              uptodateInfo.avatar = newAvatar;
            } else {
              uptodateInfo.avatar = Store.state.defaultAvatar.C2C;
            }
            uptodateInfo.nickName = response.data.result.data.name;
            Store.dispatch("setUser", uptodateInfo);
            sessionStorage.setItem("userInfo", JSON.stringify(uptodateInfo));
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    setUserProfile() {
      // console.log(this.userProfile);
      if (this.userProfile.hasOwnProperty("name")) {
        this.curUser = this.userProfile;
        this.isLoginUser = true;
      } else {
        this.updateUserProfile();
        this.isLoginUser = true;
      }
    },
    getUserPermission() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["userPermission"]["method"],
          url: apiMap["userPermission"]["url"],
          data: `token=${loginUser.token}`,
        })
        .then(function(response) {
          // console.log(response.data.result.data);
          if (response.data.result.statusCode == 1) {
            Store.dispatch("setUserPermission", response.data.result.data);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    updateFriendProfile() {
      this.getCurUserProfile(this.$route.query.id);
    },
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.id && from.query.id) {
        if (to.query.id != from.query.id) {
          this.getCurUserProfile(to.query.id); //重新加载数据
          const initUserSign = {
            feedPage: 1,
            articlePage: 1,
            albumPage: 1,
            audioPage: 1,
            videoPage: 1,
          };
          Store.dispatch("setUserCenterSign", initUserSign);
        }
      }
    },
  },
};
</script>
<style scoped>
.profile-wrapper {
  background-color: #fff;
}

.tab-content-wrap {
  width: 840px;
  min-height: 280px;
  margin-left: 10px;
}

.tab-menu-wrap {
  min-height: 200px;
  margin-top: 10px;
  text-align: center;
  background-color: #fff;
}

.menu-container {
  padding: 5px 0;
}

.menu-item {
  width: 33%;
  margin: 8px auto;
  line-height: 30px;
  cursor: pointer;
  border-radius: 3px;
}

.menu-item:hover {
  background-color: #dcecff;
}

.menu-item a {
  display: block;
  color: #000;
}

.menu-item .is-selected {
  background-color: #dcecff;
  border-radius: 3px;
}

.menu-item a span {
  display: inline-block;
  padding-left: 43px;
  line-height: 35px;
  font-size: 15px;
  background-repeat: no-repeat;
}

.feed-icon {
  background-image: url("../assets/icon/user/cl_my_feed.png");
  background-position: 4px 4px;
}

.account-icon {
  background-image: url("../assets/icon/user/cl_my_accounts.png");
  background-position: 4px 7px;
}

.profile-icon {
  background-image: url("../assets/icon/user/cl_my_profiles.png");
  background-position: 4px 7px;
}

.safety-icon {
  background-image: url("../assets/icon/user/cl_my_password.png");
  background-position: 6px 3px;
}

.tree-icon {
  background-image: url("../assets/icon/user/cl_my_trees.png");
  background-position: 4px 5px;
}

.article-icon {
  background-image: url("../assets/icon/user/cl_my_articles.png");
  background-position: 7px 4px;
}

.album-icon {
  background-image: url("../assets/icon/user/cl_my_album.png");
  background-position: 4px 6px;
}

.video-icon {
  background-image: url("../assets/icon/user/cl_my_movies.png");
  background-position: 4px 10px;
}

.audio-icon {
  background-image: url("../assets/icon/user/cl_my_audio.png");
  background-position: 4px 5px;
}
</style>
